import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Waveform.scss';
const Waveform = ({ size = 35, color = 'black', speed = 1, stroke = 3.5, }) => {
    return (_jsx("div", { className: styles.container, style: {
            '--uib-size': size + 'px',
            '--uib-color': color,
            '--uib-speed': speed + 's',
            '--uib-stroke': stroke + 'px',
        }, children: _jsxs("div", { className: styles.inner, children: [_jsx("div", { className: styles.bar }), _jsx("div", { className: styles.bar }), _jsx("div", { className: styles.bar }), _jsx("div", { className: styles.bar })] }) }));
};
export default Waveform;
